import React, { useRef, useEffect, useState } from 'react';

import { getTranslation } from '../../../../../../../../../common/react/utils/translations';
import { getPlayerHeadshotSize } from '../../../../common/utils/get-player-headshot-size';
import { useSeasonYear } from '../hooks';
import { STATS_CATEGORY_IDS } from '../../../../common/config/performance-stats';
import { BenchmarkLabel } from '../../../../../../../../../common/react/components/benchmarking/BenchmarkLabel';

const CLASS_BLOCK = 'performance-chart-tooltip';

export const CustomTooltip = ({ active, payload, label, player, stat }) => {
    const seasonYear = useSeasonYear();
    const ref = useRef();

    const statTranslation = getTranslation(
        'label.performanceChart.' + STATS_CATEGORY_IDS[stat]
    );

    useEffect(() => {
        if (ref.current) {
            // @ts-ignore
            new PULSE.app.PlayerHeadshot(ref.current);
        }
    }, [ref, active]);

    if (active && payload.length) {
        return (
            <div className={CLASS_BLOCK} ref={ref}>
                <div className={`${CLASS_BLOCK}__row`}>
                    <div>
                        <div className={`${CLASS_BLOCK}__name`}>
                            {' '}
                            {`${player.playerDetails.givenName} ${player.playerDetails.surname}`}
                        </div>
                        {payload[0].payload.subtext && (
                            <div className={`${CLASS_BLOCK}__subtext`}>
                                {payload[0].payload.subtext}
                            </div>
                        )}
                    </div>
                    <div className={`${CLASS_BLOCK}__headshot-wrapper`}>
                        <div
                            className="js-player-image"
                            data-player={player.playerId.replace('CD_I', '')}
                            data-size={getPlayerHeadshotSize(seasonYear)}
                            data-picture-in-view="false"
                            data-year={seasonYear}
                        />
                    </div>
                </div>

                <div
                    className={`${CLASS_BLOCK}__row ${CLASS_BLOCK}__row--align-end`}
                >
                    <div className={`${CLASS_BLOCK}__stat`}>
                        <span>{payload[0].value} </span>
                        <span>
                            {STATS_CATEGORY_IDS[stat] === 'dreamTeamPoints'
                                ? getTranslation(
                                      'label.performanceChart.pointsAbbreviation'
                                  )
                                : statTranslation}
                        </span>
                    </div>
                    {payload[0].payload.benchmark && (
                        <div className={`${CLASS_BLOCK}__benchmark`}>
                            <BenchmarkLabel
                                benchmarkKey={payload[0].payload.benchmark}
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    }

    return null;
};
